import script from "./disabledCard.vue?vue&type=script&setup=true&lang=js"
export * from "./disabledCard.vue?vue&type=script&setup=true&lang=js"

import "./disabledCard.vue?vue&type=style&index=0&id=fdda2b02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdda2b02"]])

export default __exports__